import "./App.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./views/home";
import CRUD from "./views/crud";

const baseURL = "https://api.bsitescomp.com/api/mda-arquitectura/";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home baseURL={baseURL} />} />
        <Route path="/Inicio" element={<Home baseURL={baseURL}/>} />
        <Route path="/crud" element={<CRUD baseURL={baseURL}/>} />
      </Routes>
    </Router>
  );
}

export default App;
